import Swiper, { Navigation, Pagination, EffectCreative } from 'swiper';
// import 'swiper/css';

// import 'swiper/css/bundle';

export function initDefaultSwiper() {
	const _ = new Swiper(".default-swiper", {
		modules: [Navigation, Pagination],
		// Default parameters
		slidesPerView: 1,
		spaceBetween: 10,
		// Responsive breakpoints
		breakpoints: {
			320: {
				slidesPerView: 2,
				spaceBetween: 24,
			},
			480: {
				slidesPerView: 3,
				spaceBetween: 24,
			},
			769: {
				slidesPerView: 4,
				spaceBetween: 24,
			},
		},
		navigation: {
			nextEl: ".default-swiper-button-next",
			prevEl: ".default-swiper-button-prev",
		},
		pagination: {
			el: ".default-swiper-pagination",
		},
	});
}

export function initCreativeSwiper() {
  const _ = new Swiper(".creative-swiper", {
		// Default parameters
    modules: [Navigation, EffectCreative],
    slidesPerView: 1,
    spaceBetween: 30,
    // centeredSlides: true,
    effect: "creative",
    creativeEffect: {
      prev: {
        shadow: true,
        translate: ["-125%", 0, -800],
        // rotate: [0, 0, -90],
      },
      next: {
        shadow: true,
        translate: ["125%", 0, -800],
        // rotate: [0, 0, 90],
      },
    },
		navigation: {
			nextEl: ".creative-swiper-next",
			prevEl: ".creative-swiper-prev",
		},
	});	
}